import { media, products, site } from "../content";
import { TextLink } from "./TextLink";

export function SoftwareSection() {
  return (
    <section className="software" id="work" aria-labelledby="software-title">
      <h2 className="software__label" id="software-title">Software</h2>
      {products.map((product) => (
        <article className="product" key={product.id} aria-labelledby={`${product.id}-title`}>
          <div className="product__heading">
            <h3 id={`${product.id}-title`}>
              <img
                className="product__icon"
                src={product.icon}
                alt=""
                width={44}
                height={44}
                loading="lazy"
                decoding="async"
              />
              {product.name}
            </h3>
            <p className="product__platform">{product.platform}</p>
          </div>
          <div className="product__details">
            <p>{product.description}</p>
            <TextLink className="product__link" href={product.href}>
              {product.action}
            </TextLink>
          </div>
        </article>
      ))}
    </section>
  );
}

export function MediaSection() {
  return (
    <section className="software" id="media" aria-labelledby="media-title">
      <h2 className="software__label" id="media-title">Media</h2>
      {media.map((item) => (
        <article className="product" key={item.id} aria-labelledby={`${item.id}-title`}>
          <div className="product__heading">
            <h3 id={`${item.id}-title`} lang="ja">
              {item.name}
            </h3>
            <p className="product__platform">{item.platform}</p>
          </div>
          <div className="product__details">
            <p>{item.description}</p>
            <TextLink className="product__link" href={item.href}>
              {item.action}
            </TextLink>
          </div>
        </article>
      ))}
    </section>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} {site.name}</p>
    </footer>
  );
}
